
<template>     
    <v-navigation-drawer app
      v-model="drawer"
      :color="color"
      :expand-on-hover="expandOnHover"
      :mini-variant="miniVariant"
      :right="right"
      :src="bg"          
      dark      
    >
      <v-layout align-center justify-space-between column fill-height>
        <v-list
          dense
          nav
          class="py-0"
        >
          <v-list-item two-line @click="resetPassword" link>
            <v-list-item-avatar>
              <img src="https://pbs.twimg.com/profile_images/634720991588020225/Gtl85bxs_400x400.jpg">
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title 
                >{{ this.userNameSurname }}</v-list-item-title>
              <v-list-item-subtitle>{{ this.userTitle }}</v-list-item-subtitle>                
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item
            v-for="item in items"
            :key="item.title"
            :to="item.link"
            link
            active-class="black--text"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        
          <v-divider></v-divider>

          <v-list-group 
            v-for='item in groupItemsComputed' 
            :key="item.title"
            :to="item.link"
            link>
              <v-list-item slot='activator'>
                  <v-list-item-icon>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>{{item.title}}</v-list-item-title>
              </v-list-item>
              <v-list class='py-0 pl-1'>
                  <v-list-item  class='py-0 pl-1'
                    v-for='child in item.children' 
                    :key="child.title"
                    :to="child.link"
                    link
                    active-class="black--text">
                    <v-list-item-icon>
                      <v-icon>{{ child.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{child.title}}</v-list-item-title>               
                  </v-list-item>
              </v-list>
          </v-list-group>
        </v-list>
        <v-btn
          justify-end                        
          @click="logout"
        ><v-icon>mdi-logout</v-icon></v-btn>
      </v-layout>
    </v-navigation-drawer>
</template>

<script>
const SIGNOUT_API_URL = 'users/signout';
const MENU_ITEMS_API_URL = 'definitions/menuItems/user/';
import auth from '../store/auth.js'
export default {
    name : 'LeftMenu',
    data () {
        return {
        userNameSurname: {},
        userTitle: {},
        userId: '',
        drawer: true,
        allItems: [],
        groupItems: [],
        color: 'primary',
        colors: [
          'primary',
          'blue',
          'success',
          'red',
          'teal',
        ],
        right: false,
        miniVariant: false,
        expandOnHover: true,
        background: true,
        }
    },
    async created() {
      this.userNameSurname =  auth.getters.getUserInfo.userNameSurname; 
      this.userTitle = auth.getters.getUserInfo.userTitle;  
      this.userId = auth.getters.getUserInfo.userId;  
      await this.getItems();
    },
    computed: {
        bg () {
          return this.background ? 'https://cdn.vuetifyjs.com/images/backgrounds/bg-2.jpg' : undefined
        },
        groupItemsComputed(){

          return this.allItems.filter((p) => {
                return (p.isGroupHeader == 1)
              }).map((item) => {
                item.children = this.allItems.filter((p) => {
                                return (p.parentLink == item.link)
                                });
                return item;  
              });
        },  
        items(){
          return this.allItems.filter((p) => {
                return (p.isGroupHeader == 0 && ( p.parentLink=='' || p.parentLink == null ))
              });
        }
    },
    methods: {
      getItems(){
        if(auth.getters.getAuthMenuItems.length == 0){
          this.$axios.get(this.$apiurl+ MENU_ITEMS_API_URL + localStorage.getItem('user_name'))        
          .then(response => {                
            this.allItems = response.data;
            auth.state.authMenuItems = response.data;
          }) 
          .catch(error => {            
          }); 
        }else{
          this.allItems = auth.getters.getAuthMenuItems;
        }
      },
      logout (){
        auth.dispatch('setUserInfo', {});
        this.$axios.post(this.$apiurl+SIGNOUT_API_URL)        
        .then(response => {                
          localStorage.setItem('access_token', '')
          localStorage.setItem('refresh_token', '')   
          localStorage.setItem('user_name_surname', '') 
          localStorage.setItem('user_title', '')   
          localStorage.setItem('user_id', '')                    
          this.$router.push({ name: 'login' })
        }) 
        .catch(error => {            
        }); 
      },
      resetPassword(){
        localStorage.setItem('reset_token',localStorage.getItem('access_token'));
        this.$router.push({ name: 'resetPassword' })
      }
    }
}
</script>